<template>
    <div>COLLECTOR REMITTANCE</div>
</template>